// extracted by mini-css-extract-plugin
export var section = "featuresDesktop-module--section--kKBIr";
export var inner = "featuresDesktop-module--inner--3EwTy";
export var jsAnimInit = "featuresDesktop-module--jsAnimInit--XhQ1Z";
export var list = "featuresDesktop-module--list--1ZZPN";
export var head = "featuresDesktop-module--head--2ELHa";
export var subtitle = "featuresDesktop-module--subtitle--1TNmh";
export var title = "featuresDesktop-module--title--RGyfX";
export var links = "featuresDesktop-module--links--24nJZ";
export var item = "featuresDesktop-module--item--2DoTk";
export var iconsWrap_arrow = "featuresDesktop-module--iconsWrap_arrow--1QG4M";
export var item_title = "featuresDesktop-module--item_title--5X871";
export var iconsWrap = "featuresDesktop-module--iconsWrap--1vgfK";
export var description = "featuresDesktop-module--description--2rFvk";